/**
 * Il colore di una barra di avanzamento, in funzione di quanto è piena.
 *
 * Sta qui e non dentro il componente perché è una regola, non un disegno: ha
 * dei confini (metà esatta, fine gara, evento vuoto) che si sbagliano facilmente
 * e che un test verifica in un millisecondo.
 *
 * Il colore è **ridondante**: quanto manca lo dice già la lunghezza della barra.
 * È un secondo canale per chi guarda lo schermo di sbieco, dal fondo del banco,
 * e non l'unico — chi non distingue il rosso dal verde legge la barra come
 * l'avrebbe letta comunque.
 */

/** I quattro gradini, che diventano le classi `progress--*` nel foglio di stile. */
export type ProgressTone = 'empty' | 'low' | 'mid' | 'full';

/**
 * Metà esatta è già ambra.
 *
 * La soglia è il punto in cui l'operatore smette di chiedersi «ce la facciamo?»,
 * e a metà restituito la risposta è sì: tenerlo rosso finché non si supera il
 * 50% dipingerebbe di allarme una gara che sta andando bene.
 */
export const PROGRESS_MID_THRESHOLD = 0.5;

export function progressTone(fraction: number): ProgressTone {
  // `NaN` non passa da nessuno dei confronti qui sotto — li perde tutti — e
  // finirebbe nel ramo di mezzo, cioè dipinto di ambra: un colore scelto a
  // caso per un numero che non esiste. Il grigio è la risposta onesta.
  if (Number.isNaN(fraction) || fraction <= 0) return 'empty';
  if (fraction >= 1) return 'full';
  return fraction < PROGRESS_MID_THRESHOLD ? 'low' : 'mid';
}
